import { SectionHeader } from "./Products";

const QUOTES = [
  {
    text:
      "Our coaches used to lose 15 minutes per session chasing balls. The magnetic holders changed how our lessons run.",
    name: "Marcus Wells",
    role: "Director of Operations",
    facility: "Highland Park Racquet Club · 14 courts",
  },
  {
    text:
      "We needed bright, durable court numbers that didn't look DIY. The Ball Boss delivered tournament-grade signage in three days.",
    name: "Priya Chand",
    role: "Tournament Manager",
    facility: "Coastal Pickleball Center · 22 courts",
  },
  {
    text:
      "Custom emboss with our facility logo. Members keep asking where to buy them.",
    name: "Jordan Reyes",
    role: "General Manager",
    facility: "North Lake Athletic · 8 courts",
  },
];

const FACILITY_IMG =
  "https://images.unsplash.com/photo-1737476997205-b3336182f215?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxwaWNrbGViYWxsfGVufDB8fHx8MTc4MTU0OTI1MXww&ixlib=rb-4.1.0&q=85";

export default function CaseStudies() {
  return (
    <section
      id="case-studies"
      data-testid="case-studies-section"
      className="bg-[#FAFAFA] border-b border-[#E5E5E5]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <SectionHeader
          eyebrow="04 / Facilities"
          title="Trusted by clubs, parks and tournament operators."
          sub="From municipal park departments to private clubs, our parts ship to facilities across the United States."
        />

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-0 border border-[#E5E5E5]">
          <div className="lg:col-span-5 relative min-h-[400px] bg-[#0A0A0A] border-b lg:border-b-0 lg:border-r border-[#E5E5E5]">
            <img
              src={FACILITY_IMG}
              alt="Facility action"
              className="absolute inset-0 w-full h-full object-cover opacity-95"
            />
            <div className="absolute inset-0 p-8 flex flex-col justify-end text-white">
              <div className="font-mono-bb text-[11px] tracking-widest text-[#DFFF00]">
                CASE STUDY · BB-01 + BB-02
              </div>
              <div className="font-display text-2xl md:text-3xl mt-2 max-w-md tracking-tight">
                86 courts equipped in 19 facilities across 7 states.
              </div>
              <div className="mt-4 grid grid-cols-3 gap-4 max-w-md">
                {[
                  ["19", "Facilities"],
                  ["86", "Courts"],
                  ["7", "States"],
                ].map(([k, v]) => (
                  <div key={v}>
                    <div className="font-display text-3xl">{k}</div>
                    <div className="overline text-white/70 mt-1">{v}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 bg-white divide-y divide-[#E5E5E5]">
            {QUOTES.map((q, i) => (
              <figure
                key={q.name}
                data-testid={`testimonial-${i}`}
                className="p-8 md:p-10"
              >
                <blockquote className="font-display text-xl md:text-2xl leading-snug tracking-tight">
                  <span className="text-[#DFFF00] mr-1">“</span>
                  {q.text}
                  <span className="text-[#DFFF00] ml-1">”</span>
                </blockquote>
                <figcaption className="mt-5 flex flex-wrap items-baseline gap-x-3 gap-y-1">
                  <span className="font-mono-bb text-[12px] tracking-widest">
                    {q.name.toUpperCase()}
                  </span>
                  <span className="text-[13px] text-[#525252]">{q.role}</span>
                  <span className="text-[12px] text-[#525252]">·</span>
                  <span className="text-[13px] text-[#0A0A0A]">{q.facility}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
